import { DilutionType } from "../../../models/DilutionType";

const map: Record<DilutionType, string> = {
  SERIAL_DILUTION: "Serial dilution",
  CO_FORMULATED_DILUTION: "Co-formulated dilution",
  MASTERMIX: "Mastermix (MMx)",
};

export const getDilutionTypeText = (type: DilutionType) => map[type];
